import { render, staticRenderFns } from "./NewSkillDemand.vue?vue&type=template&id=0e96b3c2&scoped=true&"
import script from "./NewSkillDemand.vue?vue&type=script&lang=ts&"
export * from "./NewSkillDemand.vue?vue&type=script&lang=ts&"
import style0 from "./NewSkillDemand.vue?vue&type=style&index=0&id=0e96b3c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96b3c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VPagination,VProgressCircular,VRow})
